import { Schema } from "effect";
import { StationId } from "@workerstation/shared/station-id";
import { WorkspaceId } from "@workerstation/shared/development-identifiers";
import { StationRevision } from "@workerstation/shared/station/http";
import { WorkspaceFiles } from "@workerstation/shared/station/workspace-input";

export const WorkspaceTarget = Schema.Struct({ stationId: StationId, workspaceId: WorkspaceId });
export type WorkspaceTarget = typeof WorkspaceTarget.Type;
export const WorkspaceDraft = Schema.Struct({ files: WorkspaceFiles, openTabs: Schema.Array(Schema.String), currentFile: Schema.optionalKey(Schema.String), folders: Schema.Array(Schema.String) });
export type WorkspaceDraft = typeof WorkspaceDraft.Type;
export const WorkspaceVersionObservation = Schema.Struct({ updatedAt: Schema.optionalKey(Schema.Number), refRevision: Schema.optionalKey(Schema.Number), commitId: Schema.optionalKey(Schema.String) });
export type WorkspaceVersionObservation = typeof WorkspaceVersionObservation.Type;
export const WorkspaceVersion = Schema.Struct({
  legacyUpdatedAt: Schema.optionalKey(StationRevision),
  repository: Schema.optionalKey(Schema.Struct({ revision: StationRevision, commitId: Schema.optionalKey(Schema.String) }))
});
export type WorkspaceVersion = typeof WorkspaceVersion.Type;
export const workspacePersistenceKey = (target: WorkspaceTarget): string => JSON.stringify(["workspace", target.stationId, target.workspaceId]);
